// SendOnEnterPlugin.tsx
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { COMMAND_PRIORITY_HIGH, KEY_ENTER_COMMAND } from "lexical";
import { useEffect } from "react";

type Props = {
  onSend: () => void;
};

export function SendOnEnterPlugin({ onSend }: Props) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    // Editor にコマンド登録 - Use COMMAND_PRIORITY_HIGH instead of EDITOR
    return editor.registerCommand(
      KEY_ENTER_COMMAND,
      (event) => {
        if (!event) {
          return false; // イベントがない場合は無視
        }

        // Shift+Enter は改行挿入なので無視
        if (event.shiftKey) {
          return false;
        }

        event.preventDefault(); // デフォルトの改行を抑制
        onSend(); // 親から渡された送信コールバックを呼び出し
        return true; // 他のハンドラに渡さない
      },
      COMMAND_PRIORITY_HIGH, // Use higher priority than EDITOR
    );
  }, [editor, onSend]);

  return null;
}
